// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"b734521aa328d9e2dfc9","3180":"414653f82e0f8a7fd2c8","5473":"3f5d65e8d77f60e802ba"}[chunkId] + ".css";
};